<script lang="ts">
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'NotFound',
  components: { AppButton },
};
</script>

<script setup lang="ts">
import src from '@/assets/images/not_found.svg';

defineProps<{
  subText?: string;
}>();
</script>

<template>
  <div class="grid grid-cols-[0.4fr] content-center items-center justify-center justify-items-center h-[60vh]">
    <img :src="src" alt="Not Found" class="mx-auto w-full h-auto max-h-[30vh]" />
    <h2 class="mt-4 text-center">Not Found</h2>
    <p class="text-center">{{ subText }}</p>
    <router-link to="/" class="text-center">
      <AppButton primary>Go Home</AppButton>
    </router-link>
  </div>
</template>
